import type {
  Hotel,
  HotelDealInfo,
  HotelListResponse,
} from "../../api/HotelListResponse";
import type { SupportedCurrencyCode } from "../../utils/currency";
import type { HotelProviderKind } from "../../utils/types/accommodationProviders";
import type { KoddiUrlData } from "../Koddi/KoddiResponse";

export function hotelsScreenAdapter(
  hotelListResponse: HotelListResponse,
  numOfHotels = 12,
): HotelsScreenViewModel {
  const { hotelList } = hotelListResponse;

  const defaultFilteredHotels = hotelList ?? [];

  const hotels = defaultFilteredHotels
    .slice(0, numOfHotels)
    .map((hotel: Hotel) => ({
      provider: hotelListResponse.provider,
      hotelId: hotel.hotelId,

      title: hotel.hotelName,
      coordinates: { lat: hotel.lat, lng: hotel.lng },
      imageUrl: hotel.imageUrl,
      hotelPropertyType: hotel.hotelTypeId,
      starRating: hotel.rating > 0 ? hotel.rating : undefined, // Expedia hotels have -1 rating. TODO: Remove rating on backend & make this optional.
      review:
        hotel.reviewCount > 0 && hotel.reviewScore > 0
          ? {
              score: hotel.reviewScore,
              count: hotel.reviewCount,
            }
          : undefined,
      districtName: hotel.districtName,

      price:
        hotel.minRate > 0
          ? {
              value: hotel.minRate,
              currency: hotelListResponse.currencyCode,
            }
          : undefined,
      deal: hotel.deal,
      freeCancellation: hotel.freeCancellation,

      ...(hotel.sponsoredInfo && { sponsoredInfo: hotel.sponsoredInfo }),
    }));

  return { hotels, numDefaultFilteredHotels: defaultFilteredHotels.length };
}

export type HotelViewModel = {
  provider: HotelProviderKind;
  hotelId: string;

  title: string;
  coordinates: { lat: number; lng: number };
  imageUrl: string;
  hotelPropertyType: number;
  starRating?: number;
  review?: { score: number; count: number };
  districtName?: string;

  price?: { value: number; currency: SupportedCurrencyCode };
  deal?: HotelDealInfo;
  freeCancellation?: boolean;

  sponsoredInfo?: KoddiUrlData;
};

type HotelsScreenViewModel = {
  hotels: HotelViewModel[];
  numDefaultFilteredHotels: number;
};
